import { network } from 'services/network';

export const deleteMapping = (params) => {
    return network.post('api/bo/phaseperformance/deleteMapping', params).then((response) => response.data);
};
